import { checkAttachmentName } from '@features/category/application/services/category.utils';
import { Category } from '@features/category/domain/models/category.models';
import { MenuCategory } from '@features/category/domain/models/menu-category.model';
import { ProductPublicModels } from '@features/products/product';
import { AttachmentsEnums } from '@shared/header/services/attachments.enums';

export function xmediaDefault0UseCase(
    product: ProductPublicModels.PublicProduct,
    category: Category | MenuCategory,
    defaultSet0Activated: boolean
): number | null {
    const isZoom2o3AttEnabled = checkAttachmentName(category, AttachmentsEnums.SHOW_SET0_ZOOM2)
        || checkAttachmentName(category, AttachmentsEnums.SHOW_SET0_ZOOM3);

    if (isZoom2o3AttEnabled && defaultSet0Activated) {
        return 0;
    }

    return product.xmediaDefaultSet;
}
